import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dumbbell } from 'lucide-react';
import { Button } from '../ui/button';

const Layout = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800/50">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <Dumbbell className="w-6 h-6 text-purple-500" />
              <span className="text-xl font-bold text-white">ShapeGirls</span>
            </Link>

            <nav className="flex items-center gap-8">
              <Button 
                onClick={() => navigate('/quiz')}
                className="h-10 px-6 rounded-full bg-purple-600 hover:bg-purple-500 text-white font-medium">
                Starten
              </Button>
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-16">
        {children}
      </main>

      <footer className="py-12 border-t border-zinc-800">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-zinc-500">© 2025 ShapeGirls. Alle Rechte vorbehalten.</p>
            <nav className="flex items-center gap-6">
              <Link to="/impressum" className="text-zinc-500 hover:text-zinc-300 transition-colors">Impressum</Link>
              <Link to="/agb" className="text-zinc-500 hover:text-zinc-300 transition-colors">AGB</Link>
              <Link to="/datenschutz" className="text-zinc-500 hover:text-zinc-300 transition-colors">Datenschutz</Link>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
